var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('Echart',{ref:"cEchart",attrs:{"options":_vm.options,"id":"centreRight2Chart1","height":"290px","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }